export default __webpack_public_path__ + "static/hetzner_community_8-ebfaf6bfcecbde2c2acf345bf7514545.jpg";